import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Ruler } from 'lucide-react';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const links = [
    { to: '/', label: 'Home' },
    { to: '/brands', label: 'Brands' },
    { to: '/find-my-size', label: 'Find My Size' },
    { to: '/compare', label: 'Compare' },
    { to: '/conversions', label: 'Conversions' },
    { to: '/body-type-guide', label: 'Style Guide' },
    { to: '/blog', label: 'Blog' },
  ];
  const active = (p) => loc.pathname === p ? 'text-[#C5A028] font-bold' : 'text-[#78716C] hover:text-[#1C1917]';

  return (
    <nav role="navigation" aria-label="Main navigation" className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#E8E2D9]">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-[#C5A028] focus:text-white focus:px-4 focus:py-2 focus:rounded" data-testid="skip-to-content">Skip to content</a>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <Ruler className="w-6 h-6 text-[#C5A028]" />
          <span className="font-['Cormorant_Garamond'] text-xl font-bold tracking-tight text-[#1C1917]">TrueFitGuide</span>
        </Link>
        <div className="hidden md:flex items-center gap-6">
          {links.map(l => (
            <Link key={l.to} to={l.to} className={`text-sm font-medium transition-colors duration-200 ${active(l.to)}`} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g,'-')}`}>{l.label}</Link>
          ))}
        </div>
        <button onClick={() => setOpen(!open)} className="md:hidden p-2" aria-label="Toggle menu" aria-expanded={open} data-testid="mobile-menu-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-[#E8E2D9] px-4 pb-4">
          {links.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className={`block py-3 text-sm font-medium border-b border-[#E8E2D9] last:border-0 ${active(l.to)}`}>{l.label}</Link>
          ))}
        </div>
      )}
    </nav>
  );
}
